<template>
  <GInputFormat
    v-bind="$attrs"
    v-on="$listeners"
    :value="value"
    @input="updateValue"
    :mask="getMaskOptions"
  >
    <template #right-addon>
      <slot name="right-addon" />
    </template>
  </GInputFormat>
</template>
<script>
import GInputFormat from '@trendyol-js/grace/core/GInputFormat';

export default {
  name: 'GInputQuantity',
  props: {
    value: {
      type: [Number, String],
      default: () => null,
    },
  },
  components: { GInputFormat },
  data () {
    return {
      getMaskOptions: {
        alias: 'decimal',
        rightAlign: false,
        placeholder: '',
        radixPoint: '',
        scale: 3,
        groupSeparator: '.',
        allowMinus: false,
      },
    };
  },
  methods: {
    updateValue (value) {
      this.$emit('input', value);
    },
  },
};
</script>
